import { DeviationDetailType, DeviationRequestStatus, DeviationType, DeviationWorkflowType } from 'model/business-enums';
import { PersonInfo } from 'model/business-types';
import { FileResponse, QueryParams } from 'model/essential-types';
import { EntityBase, EnumInfo } from 'model/platform-types';

export abstract class DeviationRequestsListApi {
  abstract queryDeviationRequests(type: DeviationRequestsQueryType, filter: DeviationRequestsQueryFilter, params: QueryParams): Promise<DeviationRequestsQueryRecord[]>;
  abstract downloadDeviationRequests(type: DeviationRequestsQueryType, filter: DeviationRequestsQueryFilter, params: QueryParams): Promise<FileResponse>;
}

export enum DeviationRequestsQueryType {
  User = 1,
  EntityWide = 2,
  ForReview = 3,
  Reviewed = 4,
  All = 5
}

export interface DeviationRequestsQueryFilter {
  text: string | null;
  from: string | null;
  to: string | null;
  statusValue: DeviationRequestStatus | null;
  deviationTypesOption: DeviationTypesOption | null;
  deviationType: DeviationType | null;
  detailType: DeviationDetailType | null;
  workflowType: DeviationWorkflowType | null;
  includeArchived: boolean;
}

export interface DeviationTypesOption {
  deviationType: DeviationType | null;
  detailType: DeviationDetailType | null;
  workflowType: DeviationWorkflowType | null;
}

export interface DeviationRequestsQueryRecord extends EntityBase {
  typeInfo: string;
  requestedBy: PersonInfo;
  assignedTo: PersonInfo | null;
  from: string | null;
  to: string | null;
  travelers: PersonInfo[];
  deviationType: EnumInfo<DeviationType>;
  detailType: EnumInfo<DeviationDetailType>;
  workflowType: EnumInfo<DeviationWorkflowType>;
  status: EnumInfo<DeviationRequestStatus>;
  statusChangedOn: string;
  statusChangedBy: PersonInfo;
  detailInfo: string;
  detailAdditionalInfo: string;
  isActive: boolean;
}
